import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import attachFindingFolder from '../attachFindingFolder';
import attachFindingDocument from '../attachFindingDocument';
import attachFindingReportFolder from '../attachFindingReportFolder';
import attachFindingReport from '../attachFindingReport';
import controller from './attach-finding-dialog.controller';
import template from './attach-finding-dialog.html';


class dialogService {
  getOptions($event, { serviceId, findingId, folder }) {
    return {
      controller,
      controllerAs: 'attachFindingDialogVM',
      locals: {
        serviceId,
        findingId,
        folder
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.attachFindingDialog', [
  alerts,
  amDataService,
  attachFindingDocument,
  attachFindingFolder,
  attachFindingReport,
  attachFindingReportFolder,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .service('attachFindingDialog', dialogService)
  .name;
